import React from 'react'
import '../../_metronic/partials/MapComponents/MapDetail.css'
import {Link} from 'react-router-dom'
import {KTSVG} from '../../_metronic/helpers'
import {
  ChartsWidget1,
  TablesWidget1,
  ListsWidget5,
  TablesWidget5,
} from '../../_metronic/partials/widgets'
import {useParams} from 'react-router-dom'
import company from '../../_metronic/assets/images/company.png'

const CompanyDetail = () => {
  const {detail} = useParams()
  let now = new Date()
  const day = now.toString()

  return (
    <>
      <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
        <div className='card-header cursor-pointer'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>Company 1 Details Page</h3>
          </div>

          <Link to='/company/detail/edit-company' className='btn btn-primary align-self-center'>
            {/* Link değişecek */}
            Edit
          </Link>
        </div>

        <div className='card-body p-9'>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Company Name</label>

            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>Company Name</span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Company Logo</label>

            <div className='col-lg-8 map_cards'>
              <span className='map_item'>
                <img className='map_img' src={company} alt='' />
              </span>
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Company Description</label>

            <div className='col-lg-8 fv-row'>
              <p className='fw-semibold text-dark h6'>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Similique dicta, nisi esse
                mollitia dolore et. Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Similique dicta, nisi esse mollitia dolore et. Lorem ipsum dolor sit amet
                consectetur adipisicing elit. Similique dicta, nisi esse mollitia dolore et.
              </p>
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Company Members</label>

            <div className='col-lg-8 d-flex align-items-center'>
              <span className='fw-bolder fs-6 me-2'>Member id1, Member id2, Member id3</span>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default CompanyDetail
